import { api, post } from '../../service';
import { AUTH_PERMANENT } from '../../libs/enum';

const defaultState = () => ({
    search: {
        bind: -1,
        size: 10,
        page: 1,
        key: '',
    },
    total: 0,
    devices: [],
});

const moduleDevice = {
    namespaced: true,
    state: defaultState(),
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        async getDevices({ commit, state, rootState }) {
            const params = Object.assign({}, state.search, {
                agentId: rootState.userInfo.agentId,
            });
            const res = await post(api.device.search, params);
            commit('changeDevices', res);
        },
        changeSearch({ commit, dispatch }, data) {
            commit('changeSearch', data);
            dispatch('getDevices');
        },
    },
    mutations: {
        resetState(state) {
            Object.assign(state, defaultState());
        },
        changeDevices(state, data) {
            const list = [...data.devices];
            list.forEach(item => {
                if (item.auth === AUTH_PERMANENT) {
                    const time = new Date();
                    let year = time.getFullYear();
                    let month = time.getMonth() + 1;
                    if (month === 12) {
                        year += 1;
                        month = '01';
                    } else {
                        if (month < 9) {
                            month = `0${month + 1}`;
                        } else if (month === 9) {
                            month = 10;
                        } else {
                            month = month + 1;
                        }
                    }
                    let day = time.getDate();
                    day = day < 10 ? `0${day}` : day;
                    const newTime = `${year}-${month}-${day} 00:00:00`;
                    item.expireTime = newTime;
                }
            });
            state.total = data.totalCount;
            state.devices = list;
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
    },
};

export default moduleDevice;
